import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../common/types';
import { upgradeMessages } from '../music24/components/SMLUpgradeModal/upgradeMessages';
import { teamOwnerMessages } from './teamOwnerMessages';
import { emailInitials } from './emailInitials';
import { WorkspaceOwner } from './useWorkspaceOwner';
import styles from './TeamOwnerNote.module.scss';

interface TeamOwnerNoteProps {
  owner: WorkspaceOwner | null;
  className?: string;
}

/**
 * Design o1–o3: what a team member sees in place of a checkout button — an avatar for the
 * workspace owner, the "ask the owner" headline and their email. Renders nothing while the owner
 * row hasn't loaded yet (`useMyTeamRole` already reads a loading `team.list` as OWNER, so a
 * member-only caller of this component always has the row by the time it renders).
 */
const TeamOwnerNoteComponent: React.FC<TeamOwnerNoteProps> = ({ owner, className }) => {
  const intl = useIntl();
  if (owner === null) {
    return null;
  }
  return (
    <div className={clsx(styles.note, className)}>
      <div className={styles.avatar} aria-hidden="true">
        {emailInitials(owner.email)}
      </div>
      <div>
        <b className={styles.title}>{intl.formatMessage(upgradeMessages.memberCta)}</b>
        <small className={styles.body} data-clarity-mask="true">
          {intl.formatMessage(teamOwnerMessages.managesBilling, { email: owner.email })}
        </small>
      </div>
    </div>
  );
};

export const TeamOwnerNote = TypedMemo(TeamOwnerNoteComponent);
